import { atom } from "recoil";

export const isDarkAtom = atom({
    key: "Dark",
    default: true,
});
export const isSidebarAtom = atom({
    key: "Sidebar",
    default: true,
});
export const isFullScreenAtom = atom({
    key: "Fullscreen",
    default:false,
});
